import getHistoryDuration from './src/histories'
import FontStyle from './src/fonts'
import useDidMountEffect from './src/Hooks/useDidMountEffect'
import useCallbackOnce from './src/Hooks/useCallbackOnce'
import renderWithTheme from './src/renderWithTheme'

export {
  textStyle,
  buttonSizes,
  buttons,
  texts,
  inputs,
  dropdowns,
  checkboxes,
  radios
} from './src/variants'

export {
  FontStyle,
  getHistoryDuration,
  useCallbackOnce,
  useDidMountEffect,
  renderWithTheme
}
